<template>
  <div>
    <router-link :to="`/${$route.params.locale}/${back}`"><button type="button" class="btn btn-outline-primary back-button"><font-awesome-icon icon="chevron-left" class="mr-2" />{{ $t('back_button') }}</button></router-link>
    <p class="h2 text-center mt-sm-4 mt-md-5 mt-4 mb-2">{{ $t('title_'+ $route.params.step) }}</p>
    <hr class="underline mb-4 mb-sm-4 mb-lg-5">
    <div class="row ml-sm-2 ml-md-4 ml-1 mr-sm-2 mr-md-4 mr-1">
        <div v-for="vignette in vignettes" :key="vignette.text" class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4">
          <div class="vignette">
            <div class="cover"></div>
            <img class="w-100" :src="getImage(vignette.image)" />
            <!-- <div class="description">
              <div class="line"></div>
              <p class="h5">{{ $t(vignette.text+'_description') }}</p>
            </div> -->
            <div class="descripcion-black">
              <div class="line"></div>
              <p class="h5">
                {{ $t(vignette.text+'_description') }}
                <br>
                <router-link class="button-link" :to="`/${$route.params.locale}/comic/${vignette.link}`"><button class="btn btn-primary ml-auto mr-auto mt-3 mb-2 d-block">{{ $t('vignette_button') }}</button></router-link>
              </p>
            </div>
            <div class="text">
              <div class="line"></div>
              <p class="h4">{{ $t(vignette.text) }}</p>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import json from '@/vignettes';

export default {
  name: 'vignette',
  data() {
    return {
      vignettes: json[this.$route.params.step].vignettes,
      back: json[this.$route.params.step].back,
      number: 0,
      col: 0
    }
  },
  created() {
    this.number = this.vignettes.length;
    this.col = 12/this.number;
  },
  methods: {
    getImage(path) {
      return require('@/assets/'+path)
    }
    // is_touch_device() {
    //   var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    //   var mq = function(query) {
    //     return window.matchMedia(query).matches;
    //   }

    //   if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    //     return true;
    //   }

    //   // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    //   // https://git.io/vznFH
    //   var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    //   return mq(query);
    // }
  }
}
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

p.h2 {
  font-family: 'Kalam', sans-serif;
  text-transform: uppercase;
}
.underline {
  margin: 0 auto;
  border-width: 2px;
  max-width: 400px;
  border-color: #e31b18;
  margin-bottom: 25px;
}
.vignette {
    text-align: center;
    position:relative;
    cursor:pointer;
    transition: all 150ms ease-in-out;
    overflow: hidden;
    .cover {
      width: 100%;
      height: 100%;
      position: absolute;
      background-image: url('~@/assets/Fondo.png');
      background-repeat: round;
      background-size: cover; 
      z-index: 2;
    }
    img {
      padding: 4px;
      padding-bottom: 0;
    }
    .text {
      padding-bottom: 2px;
      position: relative;
      display: grid;
      height: 100%;
      .line {
        position: absolute;
        width: calc(100% - 8px);
        height: 8px;
        top: -4px;
        margin: 0 4px;
        background-size: cover;
        background-repeat: round;
        background-image: url('~@/assets/line.png');
      }
      p {
        background: white;
        padding: 20px;
        margin: 0 4px;
        text-align: center;
        letter-spacing: 0.07rem;
        font-family: 'Bangers', Arial, Helvetica, sans-serif;
      }
    }
    .descripcion-black {
      padding-bottom: 2px;
      position: absolute;
      width: 100%;
      bottom: -300px;
      overflow: hidden;
      transition: all 1s;
      z-index: 99;
      .line {
        position: relative;
        width: calc(100% - 8px);
        height: 8px;
        bottom: -4px;
        margin: 0 4px;
        background-size: cover;
        background-repeat: round;
        background-image: url('~@/assets/line.png');
      }
      p {
        height: 100%;
        background: rgba(0,0,0,0.9);
        padding: 20px;
        margin: 0 4px;
        font-size: 1.2em;
        color: white;
        text-align: center;
        font-family: 'Architects Daughter', sans-serif;
        button {
          font-family: Roboto,Noto Sans,-apple-system,BlinkMacSystemFont,sans-serif;
        }
      }
    }
    .description {
      padding-bottom: 2px;
      position: absolute;
      width: 100%;
      bottom: -300px;
      overflow: hidden;
      transition: all 1s;
      z-index: 1;
      .line {
        position: relative;
        width: calc(100% - 8px);
        height: 8px;
        bottom: -4px;
        margin: 0 4px;
        background-size: cover;
        background-repeat: round;
        background-image: url('~@/assets/line.png');
      }
      p {
        height: 100%;
        background: white;
        padding: 20px;
        margin: 0 4px;
        text-align: center;
        font-family: 'Architects Daughter', sans-serif;
      }
    }
    &:hover, &:active {
      transform: scale(1.05);
      .description, .descripcion-black {
        bottom: 0;
      }
    }
  }

  .row {
    justify-content: center;
  }

  [class*="col-"] {
    display: flex;
  }

  @include media-breakpoint-down(md) {
    .underline {
      max-width: 250px;
    }
  }

  .back-button {
    position: absolute;
    top: 100px;
    left: 35px;
    @include media-breakpoint-down(sm) {
      position: initial;
      margin-top: 15px;
      margin-bottom: -10px;
    }
  }

  .button-link:hover {
    text-decoration: none;
  }
</style>

